let baseUrl = '';
let baseUrl1 = '';
let baseUrl2 = '';
let baseUrl5 = '';
let baseUrl6 = '';
let baseSpma = "";
let baseB = "";
console.log(process.env.NODE_ENV)
switch (process.env.NODE_ENV){
  case "development":
    baseUrl = "https://pro-platform-api.dsxindianshang.com/api/v2/";
    baseUrl1 = "https://pro-platform-api.dsxindianshang.com/api/v1/";
    baseUrl2 = "https://pro-platform-api.dsxindianshang.com/api/v3/";
    baseUrl5 = "https://pro-platform-api.dsxindianshang.com/api/v5/";
    baseUrl6 = "https://pro-platform-api.dsxindianshang.com/api/v6/";

    baseB = "https://test-business-api.dsxindianshang.com/";
    // baseUrl = "https://test-platform-api.dsxindianshang.com/platform/";
    // baseUrl1 = "https://test-platform-api.dsxindianshang.com/api/v1/";
    // baseUrl2 = "https://test-platform-api.dsxindianshang.com/api/v3/"
    // baseUrl5 = "https://test-platform-api.dsxindianshang.com/api/v5/"
    // baseUrl6 = "https://test-platform-api.dsxindianshang.com/api/v6/"
    baseSpma = "https://test-spma-api.dsxindianshang.com/";
  // baseSpma = "https://spma.dsxindianshang.com";
  // baseB = "https://bussiness.dsxindianshang.com/";
    break;
  case "test":
    baseUrl = "https://test-platform-api.dsxindianshang.com/platform/";
    baseUrl1 = "https://test-platform-api.dsxindianshang.com/api/v1/";
    baseUrl2 = "https://test-platform-api.dsxindianshang.com/api/v3/"
    baseUrl5 = "https://test-platform-api.dsxindianshang.com/api/v5/"
    baseUrl6 = "https://test-platform-api.dsxindianshang.com/api/v6/"
    baseSpma = "https://test-spma-api.dsxindianshang.com/";
    // baseSpma = "https://spmadev.dsxindianshang.com";//打dev的环境的包
    baseB = "https://test-business-api.dsxindianshang.com/";
    break;
  case "production":
    baseUrl = "https://dsxindianshang.com/api/v2/";
    baseUrl1 = "https://dsxindianshang.com/api/v1/";
    baseUrl2 = "https://dsxindianshang.com/api/v3/"
    baseUrl5 = "https://dsxindianshang.com/api/v5/"
    baseUrl6 = "https://dsxindianshang.com/api/v6/"
    baseSpma = "https://spma.dsxindianshang.com";
    baseB = "https://bussiness.dsxindianshang.com/";
    break;
  case "preProduction":
    baseUrl = "https://pro-platform-api.dsxindianshang.com/api/v2/";
    baseUrl1 = "https://pro-platform-api.dsxindianshang.com/api/v1/";
    baseUrl2 = "https://pro-platform-api.dsxindianshang.com/api/v3/";
    baseUrl5 = "https://pro-platform-api.dsxindianshang.com/api/v5/";
    baseUrl6 = "https://pro-platform-api.dsxindianshang.com/api/v6/";
    baseSpma = "https://spma.dsxindianshang.com";
    baseB = "https://bussiness.dsxindianshang.com/";
    break;
}

export default {
  baseUrl, baseUrl2, baseUrl1, baseUrl5, baseUrl6, baseSpma, baseB
}



// WEBPACK FOOTER //
// ./src/utile/urls.js